import toast from "react-hot-toast";
import { allCountries } from "country-telephone-data";
import { getAgencyList } from "../requests";
import { removeUserInformation } from "../_store/reducers/userReducer";
import { clearContext } from "../_store/reducers/contextReducer";



// Toaster functions
export const notifySuccess = (msg) => toast.success(msg);

export const notifyError = (msg) => toast.error(msg);

export const getApiErrorMessage = (error, fallback = "Something went wrong") => {
  if (!error?.response) {
    const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";
    if (error?.code === "ECONNABORTED") {
      return "Request timed out. Please try again.";
    }
    return `Cannot reach the server at ${apiUrl}. Make sure the backend is running.`;
  }

  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    fallback
  );
};


// Auth token functions
export const saveAuthToken = (token) => {
  localStorage.setItem("access_token_AS", token);
};

export const deleteAuthToken = () => {
  localStorage.removeItem("access_token_AS");
};

export const isUnauthorizedError = (err) => {
  const status = Number(err?.response?.status ?? err?.status);
  if (status === 401) return true;

  const message = String(
    err?.response?.data?.message ?? err?.data?.message ?? err?.message ?? ""
  ).toLowerCase();

  return (
    message.includes("invalid or expired token") || message === "unauthorized"
  );
};

export const logoutOnUnauthorized = (err, dispatch, navigate) => {
  if (!isUnauthorizedError(err)) return false;

  deleteAuthToken();
  dispatch(removeUserInformation());
  dispatch(clearContext());
  navigate("/login");
  notifyError(
    err?.response?.data?.message ||
      err?.data?.message ||
      err?.message ||
      "Session expired. Please login again."
  );
  return true;
};


/**
 * Country codes for phone number input (dial code + country name).
 * Format: { value: dialCode (e.g. "91"), label: "+91 India" }
 */
// export const COUNTRY_CODES = [
//   { value: "93", label: "+93 Afghanistan", flag: "🇦🇫" },
//   { value: "355", label: "+355 Albania", flag: "🇦🇱" },
// ];

function getFlagEmoji(countryCode) {
  return countryCode
    .toUpperCase()
    .replace(/./g, char =>
      String.fromCodePoint(127397 + char.charCodeAt())
    );
}


export const COUNTRY_CODES = allCountries.map((country) => ({
  value: country.dialCode,
  label: `+${country.dialCode} ${country.name}`,
  flag: getFlagEmoji(country.iso2),
}));


export const getCountryCode = (phone) => {
  if(phone.split(' ').length < 2){
    return '91';
  }
  const countryCode = phone.split(' ')[0];
  return countryCode || '91';
}


export const getPhoneNumber = (phone) => {
  if(phone.split(' ').length < 2){
    return phone;
  }
  const phoneNumber = phone.split(' ')[1];
  return phoneNumber || '';
}



/**
 * Save agencies to session storage used in agencies dropdown
 * @param {Array} agencies - The agencies to save
 * @returns {null}
 */

export const saveAgencies = (agencies) => {
  try {
    if(!agencies || !Array.isArray(agencies) || agencies?.length === 0){
      return null;
    }
    sessionStorage.setItem('agencies', JSON.stringify(agencies));
  } catch (error) {
    console.log(error);
    
  }
}

export const getAgencies = async () => {

  try {
    const response = await getAgencyList();
    if(response?.status < 400 && response?.data){
      saveAgencies(response.data);
    }
    const agencies = sessionStorage.getItem('agencies');
    return agencies ? JSON.parse(agencies) : null;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export const getLatestAgency = async() => {
  try {
   
    const agencies = await getAgencies();
    if(agencies && Array.isArray(agencies) && agencies?.length > 0){
      const latestAgency = agencies.reduce((latest, current) => {
        return Number(latest.id) > Number(current.id) ? latest : current;
      },agencies[0])
      return latestAgency;
    }

    const response = await getAgencyList();
    if(response?.status < 400 && response?.data){
      saveAgencies(response.data);
      const latestAgency = response.data.reduce((latest, current) => {
        return Number(latest.id) > Number(current.id) ? latest : current;
      },response.data[0])
      return latestAgency;
    }
    return null;
  } catch (error) {
    console.log(error);
    return null;
  }

}

export const loadAgencyFromApi = async () =>{
  try {
    const response = await getAgencyList();
    if(response?.status < 400 && response?.data){
      saveAgencies(response.data);
    }
  } catch (error) {
    console.log(error);
    return null; 
  }
}

export const isRTL = (lang) =>{

  //check whether the lang is rtl
  const rtl_languages = ["arabic", "hebrew", "persian","urdu"]
  return rtl_languages.includes(lang.toLowerCase().trim()) ? true : false;

}